import http from "../http-common";

class VersionDoorDetailDataService {
  getAll(condition) {
    return http.get(`/versiondoordetail/search/?fastquotingdoorversionsId=${condition}`);
  }

  getversiondoordetailByDescr(condition,sortfield,sorttype) {
    return http.get(`/versiondoordetail/search/?fastquotingdoorversionsId=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }  

  getCondition(condition) {
    return http.get(`/versiondoordetail/search/?fastquotingdoorversionsId=${condition}`);
  }

  get(id) {
    return http.get(`/versiondoordetail/${id}`);
  }

  findById(id) {
    return http.get(`/versiondoordetail/${id}`);
  }  

  create(data) {
    return http.post("/versiondoordetail", data);
  }

  update(id, data) {
    return http.put(`/versiondoordetail/${id}`, data);
  }

  delete(id) {
    return http.delete(`/versiondoordetail/${id}`);
  }

  deletewhere(id) {
    return http.delete(`/versiondoordetail/where/${id}`);
  }  

  deleteAll() {
    return http.delete(`/versiondoordetail/items`);
  }


//////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new VersionDoorDetailDataService();
